module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAER0RVh0QUxUVGFnAEluZm9ybWF0aW9uIHNpZ24gaWNvbiwgdmVjdG9yIGlsbHVzdHJhdGlvbi4gRmxhdCBkZXNpZ24gc3R5bGVJ52b+AAAATWlUWHREZXNjcmlwdGlvbgAAAAAASW5mb3JtYXRpb24gc2lnbiBpY29uLCB2ZWN0b3IgaWxsdXN0cmF0aW9uLiBGbGF0IGRlc2lnbiBzdHlsZfulYTQAAACiSURBVHjaYvz//z8DARAAxAlA/ACIFwDxBbyqQQbiwQv+YwIHfHrwGSbwHzvYgM9AJjyOV8AhbkCJlw9gcWECuV4GYQOkcHwAxA0E1DMwEhHLIC8KIPEfQDFJXj7wHzc4QG6kkAVwGdgAxBOB+COpBrLgED8AxSCQTw0XwsAHanmZ6mE4aiDlBoJKGgccJYs9tMA1ICXrNfwnDA7QJesBBBgA4TCb4hOREewAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/info.png
// module id = 2656
// module chunks = 0